export default __webpack_public_path__ + "static/media/react-logo-primary.5760e58f.svg";